export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6205.3502089d.jpg";